export default "__VITE_ASSET__ClXbYvP4__"